if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = Array.from(this.querySelectorAll('.announcement'));
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      // AUTOPLAY settings
      this.autoplayInterval = 2000; // ms between auto moves
      this.scrollDuration = 300;    // ms for scroll animation (faster movement)
      this.autoplayTimer = null;
      this.isHovered = false;
      this.isAnimating = false;     // prevent overlapping animations

      // Guard: nothing to do if no slider or no items
      if (!this.slider || this.length === 0) return;

      // Always hide arrows if they exist
      if (this.nextButton) this.nextButton.style.display = 'none';
      if (this.prevButton) this.prevButton.style.display = 'none';

      // Start autoplay only if more than one slide
      if (this.length > 1) {
        this.startAutoplay();

        // Pause autoplay on hover/focus, resume on leave/blur
        this.slider.addEventListener('mouseenter', () => { this.isHovered = true; this.stopAutoplay(); });
        this.slider.addEventListener('mouseleave', () => { this.isHovered = false; this.startAutoplay(); });
        this.slider.addEventListener('focusin', () => { this.isHovered = true; this.stopAutoplay(); });
        this.slider.addEventListener('focusout', () => { this.isHovered = false; this.startAutoplay(); });
      }

      // Ensure first slide is visible on init (jump without animation)
      this.slider.scrollLeft = this.content[this.index].offsetLeft;
    }

    // start autoplay loop (always moves forward)
    startAutoplay() {
      if (this.autoplayTimer) return;
      this.autoplayTimer = setInterval(() => {
        if (!this.isHovered && !this.isAnimating) this.nextSlide(); // always forward
      }, this.autoplayInterval);
    }

    // stop autoplay loop
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    // go to next slide (wraps forward)
    nextSlide() {
      if (this.isAnimating) return;
      const nextIndex = (this.index + 1) % this.length;
      this.goToIndex(nextIndex);
    }

    // go to previous slide (wraps backward) — kept for completeness
    prevSlide() {
      if (this.isAnimating) return;
      const prevIndex = (this.index - 1 + this.length) % this.length;
      this.goToIndex(prevIndex);
    }

    // Public API compatibility
    changeSlide(direction) {
      if (direction === 'next') {
        this.nextSlide();
      } else if (direction === 'prev') {
        this.prevSlide();
      }
    }

    // central navigation handler
    goToIndex(targetIndex) {
      if (this.isAnimating) return;
      if (targetIndex === this.index) return;

      // set animating flag
      this.isAnimating = true;

      const target = this.content[targetIndex];
      if (!target) {
        this.isAnimating = false;
        return;
      }
      const targetLeft = target.offsetLeft;

      // If wrapping from last -> first, it's okay to animate directly (simple approach).
      // If you want a seamless infinite effect, consider cloning slides (more complex).
      this.animateScroll(this.slider, targetLeft, this.scrollDuration, () => {
        this.index = targetIndex;
        this.isAnimating = false;
      });
    }

    // requestAnimationFrame based scroll animation with callback
    animateScroll(el, to, duration, cb) {
      const start = el.scrollLeft;
      const change = to - start;
      const startTime = performance.now();

      const animate = (now) => {
        const elapsed = now - startTime;
        const t = Math.min(1, elapsed / duration); // normalized 0..1
        // easeInOutQuad easing
        const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        el.scrollLeft = Math.round(start + change * eased);
        if (t < 1) {
          requestAnimationFrame(animate);
        } else {
          if (typeof cb === 'function') cb();
        }
      };
      requestAnimationFrame(animate);
    }

    // Clean up when element removed from DOM
    disconnectedCallback() {
      this.stopAutoplay();
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}
